export default __webpack_public_path__ + "static/media/bike-repair-station.inline.3c803f8f.svg";